import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { CatList } from '@blocks-react/components/List';
import { v4 as uuid } from 'uuid';
import { EQUIPMENT_LIST_LIMIT } from '../constants';
import { MyEquipmentListItem } from './my-equipment-list-item';
export const MyEquipmentList = ({ list, onEqpuipmentSelect, searchTerm, selectedEquipment, limit = EQUIPMENT_LIST_LIMIT, children }) => {
    return (_jsx(CatList, { children: list.slice(0, limit).map((item) => (_jsx(React.Fragment, { children: _jsx(MyEquipmentListItem, { item: item, selectedEquipment: selectedEquipment, onEquipmentSelect: onEqpuipmentSelect, searchTerm: searchTerm, elementKey: uuid(), children: children }) }, uuid()))) }));
};
